import { render, staticRenderFns } from "./ListingsPackagesAndServices.vue?vue&type=template&id=c837ff08"
import script from "./ListingsPackagesAndServices.vue?vue&type=script&lang=js"
export * from "./ListingsPackagesAndServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports